import { RouteConfig } from 'vue-router';

import { feeManageRoute } from './manage.route';

export function addFeeRoute(name: string): RouteConfig {
  return feeManageRoute(name, 'add');
}
